import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import Container from 'react-bootstrap/Container';
import { ToastProvider, DefaultToastContainer } from 'react-toast-notifications';

import configureStore from './store/configureStore';
import App from './App';
import { AppSettings } from './store/ApplicationData';
import { api } from './api';
//import registerServiceWorker from './registerServiceWorker';

//extend Window interface
declare global {
    interface Window { AppSettings: AppSettings; }
}
window.AppSettings = window.AppSettings || {};

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);
// Get the build number
api.GetBuild().then((response) => response.data).then(response => {
  store.dispatch({ type: 'SET_APP_INFO', appInfo: response })
});

const ToastContainer = (props: any) => (
  <DefaultToastContainer
    style={{ paddingTop: "4em" }}
    {...props}
  />
);

ReactDOM.render(
  <ToastProvider components={{ ToastContainer }} autoDismiss autoDismissTimeout={6000} placement="top-right">
    <Provider store={store}>
        <ConnectedRouter history={history}>
          <Container fluid>
            <App />
          </Container>
        </ConnectedRouter>
    </Provider>
  </ToastProvider>,
  document.getElementById('root'));

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();

